<!--
  - Copyright (c) 2023. Haodong JU
  -->

<script>

export default {
  name: 'LastStepButton'
}
</script>

<template>
  <v-card
    class="pa-2 d-flex align-center grey lighten-3 text--secondary text-body-2"
    elevation="0"
    style="position: absolute;"
    :style="!$vuetify.breakpoint.mobile ? 'left: 64px;top:64px' : 'left: 16px;top:16px'"
    @click="$emit('back')"
  >
    <v-icon left>
      mdi-arrow-left
    </v-icon>
    {{ $t('BackToPreviousStep') }}
  </v-card>
</template>

<style scoped>

</style>
